import React from 'react';
import PropTypes from 'prop-types';

import CourseCardHead from './CourseCardHead';
import MaterialTiles from './MaterialTiles';

import './course-card.style.scss';

const PRODUCT_PAID = 5;

const TrialCourseCard = ({ course, getAccounts }) => {
  const isPaid = course.product_status === PRODUCT_PAID;

  return (
    <article className="course-card course-card--trial">
      <CourseCardHead
        image={course.image}
        title={course.direction_name}
        programName={course.program_name}
      />

      <div className="course-card__materials">
        <h4 className="course-card__subtitle">Матеріали заняття</h4>
        <MaterialTiles lesson={course} />
      </div>

      <button
        type="button"
        className={`course-card__pay ${isPaid ? 'is-paid' : ''}`.trim()}
        disabled={isPaid}
        onClick={() => getAccounts(course.product_id, 'trial_courses')}
      >
        {isPaid ? 'Оплачено' : 'Оплатити курс'}
      </button>
    </article>
  );
};

TrialCourseCard.propTypes = {
  course: PropTypes.object.isRequired,
  getAccounts: PropTypes.func.isRequired,
};

export default TrialCourseCard;
